import http from '../common/http'
//测试商家报表接口
export const getMerchantReport = param => (
  http.get('/Report/GetMerchantReport', param)
)
//测试门店报表接口
export const getStoreReport = param => (
  http.get('/Report/GetStoreReport', param)
)
//测试维修师报表接口
export const getRepairmanReport = param => (
  http.get('/Report/GetRepairmanReport', param)
)
//正式接口
export const getReportData= param => (
  http.get('/Report/GetReportData', param)
)



// WEBPACK FOOTER //
// ./src/api/reportApi.js